/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography, Popper } from '@mui/material';
import { useState } from 'react';
/**
 * Information popper component implementation
 * @param {String} information - the content which needs to show
 * @param {String} placement - where it should be shows (left to right or right to left)
 * @returns
 */
const InformationPopper = ({ information, placement = 'left-start' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <>
      <InfoOutlinedIcon
        className="info-icon"
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
        color="primary"
      />
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        placement={placement}
        disablePortal
        modifiers={[
          {
            name: 'flip',
            enabled: true,
            options: {
              altBoundary: false,
              rootBoundary: 'document',
              padding: 8,
            },
          },
          {
            name: 'preventOverflow',
            enabled: false,
            options: {
              altAxis: true,
              altBoundary: false,
              tether: false,
              rootBoundary: 'viewport',
              padding: 8,
            },
          },
        ]}
      >
        <Typography
          sx={{
            p: 2,
            backgroundColor: '#e0e0e0',
            borderRadius: 1,
          }}
        >
          {information}
        </Typography>
      </Popper>
    </>
  );
};
//
export default InformationPopper;
